<template>
  <div class="wcim__topBar" v-show="$route.meta.showHeader">
    <div class="inner flexbox flex-alignc">
      <h4 class="barTxt flex1">
        <div class="barCell flexbox flex__direction-column">
          <em class="clamp1">飞享移动版</em>
        </div>
      </h4>
      <a class="linkico wcim__ripple-fff" href="javascript:;">
        <i class="iconfont icon-search"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue